import { render, staticRenderFns } from "./notaValePremios.vue?vue&type=template&id=c49886ee&scoped=true"
import script from "./notaValePremios.ts?vue&type=script&lang=ts&external"
export * from "./notaValePremios.ts?vue&type=script&lang=ts&external"
import style0 from "./notaValePremios.vue?vue&type=style&index=0&id=c49886ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49886ee",
  null
  
)

export default component.exports